import { Anchor, Button, Container, SizableText, Stack, XStack, isWeb } from '@my/ui'
import { Share2 } from '@tamagui/lucide-icons'
import { BaseBlock } from 'app/features/shared/blocks'
import { ShareModal } from 'app/features/sharing/components'
import { ArticleBlockRenderer } from '../../blocks'
import { ArticleCategoryTag } from '../article-category-tag'
import { SolitoImage } from 'solito/image'

export interface ArticleProps {
  title: string
  shortDescription?: string
  primaryCategory?: {
    name: string
    slug: string
  }
  featuredImage: {
    url: string
    alt: string
  }
  slug: string
  content: BaseBlock[]
  shareLinkUrl?: string
  ctaButtonLabel?: string
  ctaButtonLink?: string
}

export const Article = (props: ArticleProps) => {
  return (
    <Container size="base" flex={1} justifyContent="center" alignItems="center">
      {props.featuredImage && (
        <Stack w="100%" aspectRatio={39 / 20} $gtSm={{ aspectRatio: 5 / 2 }}>
          <SolitoImage
            src={props.featuredImage?.url}
            alt={props.title}
            fill
            contentFit="cover"
            priority
            sizes="(max-width: 900px) 100vw, 900px"
          />
        </Stack>
      )}
      <Container py="$4" gap="$2" bg="$white" gutter size="base">
        <XStack gap="$3.5" justifyContent="space-between">
          <SizableText size="$8" fow="600">
            {props.title}
          </SizableText>
          {isWeb && props.shareLinkUrl && (
            <ShareModal
              href={props.shareLinkUrl}
              subject="Check out this article"
              trigger={
                <Button size="$3" px="$2" plain icon={<Share2 size={24} />} fontWeight="500">
                  Share
                </Button>
              }
            />
          )}
        </XStack>

        {props.shortDescription && (
          <SizableText width="auto" color="$grey7" size="$6">
            {props.shortDescription}
          </SizableText>
        )}

        {props?.primaryCategory?.name && (
          <ArticleCategoryTag
            name={props.primaryCategory.name}
            href={`/life/categories/${props.primaryCategory.slug}`}
            alignSelf="flex-start"
          />
        )}

        {isWeb && props.ctaButtonLink && (
          <Anchor
            textAlign="center"
            w="100%"
            fow="500"
            href={props.ctaButtonLink}
            target="_blank" //this does not affect other articles as only fresher event has ctaButton field
            minWidth="$18"
            $gtSm={{ maxWidth: '$20' }}
            backgroundColor="$primary"
            borderRadius={8}
            py="$4"
            my="$2"
          >
            {props.ctaButtonLabel || 'View'}
          </Anchor>
        )}
      </Container>
      <Container bc="$white" bblr="$3" bbrr="$3" pb="$3.5">
        <ArticleBlockRenderer content={props.content} />
      </Container>
    </Container>
  )
}
